import {
  ICharityDonationResponse,
  IDonationSkuResponse,
  IDonationSkuRequest,
} from '../CharityDonationApi';

export interface ICharityDonation {
  description: string;
  logoUrl: string;
  name: string;
  id: number;
  items: IDonationSku[];
}

export interface IDonationSku {
  skuId: number;
  amount: string;
}

const donationSkuMapper = (donationSkus: IDonationSkuResponse[]): IDonationSku[] => {
  return donationSkus.map(sku => {
    return {
      amount: sku.amount,
      skuId: sku.SKU_BASE_ID,
    };
  });
};

const donationApiMapper = {
  request(data: { skuId: number }): IDonationSkuRequest {
    return {
      QTY: 1,
      SKU_BASE_ID: data.skuId,
    };
  },
  response(data: ICharityDonationResponse): ICharityDonation[] {
    return data.donation_details.map(item => {
      return {
        description: item.donation_desc,
        id: item.prod_base_id,
        items: donationSkuMapper(item.donation_items),
        logoUrl: item.donation_logo,
        name: item.product_name,
      };
    });
  },
};

export default donationApiMapper;
